// Hook para obtener rutas desde el backend
import { useEffect, useState } from "react";
import axios from "axios";

export function useRutas() {
  const [rutas, setRutas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchRutas() {
      setLoading(true);
      try {
        const res = await axios.get(`/api/admin/verCompras/facetas`);
        setRutas((res.data && res.data.rutas) || []);
        setLoading(false);
      } catch (err) {
        setError("Error al cargar rutas");
        setLoading(false);
      }
    }
    fetchRutas();
  }, []);

  return { rutas, loading, error };
}
